import React from 'react';
import 'twin.macro';
import { Tag } from '../tag';

export const ItemTags = ({ tags = '', user }) => {
  return tags.split(' ').map((tag, index) => <Tag key={tag + index} label={tag} user={user} />);
};
